/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import ReactGA from "react-ga";
import {
  Navbar,
  Sidebar,
  LoadingSpinner,
  Settings,
  ProjectConfig,
  VirtualAgent,
  EditProfile,
} from "./components";
import {
  Subgroup,
  Campaignlevel,
  Category,
  CreateGroup,
  Editgroup,
} from "./pages/Categorize/GroupIndex.jsx";
import {
  YoyAnalysis,
  Login,
  Signup,
  ForgotPassword,
  StrategyIdeas,
  DeviceLevel,
  PlatformAnalysis,
  KeywordAnalysis,
  Editsubgroup,
  Editcategory,
  Audience,
  BrandSpecificKeyword,
  NonBrandSpecificKeyword,
  CategorySpecific,
  SubcategorySpecific,
  SubscriptionStatus,
  GetStarted,
  SignupSteps,
  PrivacyPolicy,
  GADetection,
  TrafficAnalytics,
  ForecastingTool,
  AdsPositionTool,
  GADetectionTool,
  CampaignsTable,
  Adgroup,
  Changehistory,
  Searchkeywords,
  Ads,
  AdCrafting,
  GoogleAdsOverview,
  Projects,
  ProjectList,
  EditProject,
  CreateProject,
  GoogleAdsDailyReporting,
  GoogleAdsAlerts,
  BingAdsAlerts,
  ProjectDetails,
  Billing,
  CreateTask,
  PaidAdsPage,
  SupportPage,
  GoogleAdsWeeklyReporting,
  CreateDetails,
  SearchTerms,
  CampaignPlanning,
  GoogleAdsMonthlyReporting,
  ErrorBoundary,
  AddNotes,
  ChangeLog,
  PromoRecap,
  CustomColumnPerformance,
  ResetPassword,
  CustomReporting,
  CampaignsGroupBy,
  CreateCustomColumn,
  OnboardingAudit,
  PromptPage,
  Location3,
  ChannelPage,
  BidStrategies,
  RequestAccess,
} from "./pages/index";
import "./App.css";
import { useStateContext } from "./contexts/ContextProvider";
import { Navigate } from "react-router-dom";
import VideoCallPage from "./components/VideoCall";
import Submenu from "./components/SubSidebar";
import CustomDateRangePicker from "./styles/CustomDateRangePicker";
import ServerDownPopup from "./components/ServerDownDropDown.jsx";
import axios from "axios";
import { fetchPlanDetails } from "./pages/config/apiHelper.jsx";

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);

const App = () => {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    const pathsToClear = ["/projects" || "/ads-project-performance"];
    if (pathsToClear.includes(path)) {
      localStorage.removeItem("project_name");
    }
  }

  // const location = useLocation();

  const isVirtualAgentPath =
    window.location.pathname.toLowerCase() === "/virtual-agent";

  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isServerDown, setIsServerDown] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
    setIsLoggedIn(!!token);
    setActiveMenu(!!token);

    if (token) {
      userHasActiveProjects();
    } else {
      setIsLoading(false);
    }

    fetchPlanDetails();
  }, [setCurrentColor, setCurrentMode, token]);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isNetworkError =
          error.code === "ERR_NETWORK" && error.message !== "canceled";

        const isCriticalError =
          error.response && [502, 503, 504].includes(error.response.status);

        if (isNetworkError || isCriticalError) {
          console.error("Critical Server Issue Detected:", error.message);
          setIsServerDown(true);
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  const handleLogin = async (email) => {
    try {
      setIsLoggedIn(true);
      setActiveMenu(true);
      localStorage.setItem("isLoggedIn", "true");

      const response = await fetch(
        "https://api.confidanto.com/projects-data/check-projects",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        },
      );
      window.location.href = "/";
      return;
    } catch (error) {
      console.error("Login redirect error:", error);
    }
  };

  const ClearProjectNameOnNavigate = () => {
    const location = useLocation();
    useEffect(() => {
      const handleResize = () => {
        const zoomAdjustedWidth = window.innerWidth / window.devicePixelRatio;
        setActiveMenu(zoomAdjustedWidth >= 524);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
      const pathsToClear = ["/projects" || "/ads-project-performance"];
      if (pathsToClear.includes(location.pathname)) {
        localStorage.removeItem("project_name");
      }
    }, [location.pathname]);

    return null;
  };

  const toggleSidebar = () => {
    setActiveMenu(!activeMenu);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setActiveMenu(false);
    localStorage.removeItem("token");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("project_id");
    localStorage.removeItem("daysLeftStatus");
  };

  const [hasActiveProjects, setHasActiveProjects] = useState(false);
  const userHasActiveProjects = async () => {
    await axios
      .post("https://api.confidanto.com/projects-data/project-list", {
        email: localStorage.getItem("email"),
      })
      .then((res) => {
        let activeProjects = res?.data
          ?.filter((item) => item.ad_accounts && item.ad_accounts.length > 0)
          .map((item) => item);

        if (activeProjects.length > 0) {
          setHasActiveProjects(true);
        }
      })
      .catch((err) => {
        console.error("Error Fetching Projects: ", err);
      })
      .finally((fin) => {
        setIsLoading(false);
      });
  };

  const handleRetry = () => {
    setIsServerDown(false);
    window.location.reload();
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div
      className={`${
        currentMode === "Dark" ? "dark" : ""
      } min-h-screen flex flex-col overflow-x-hidden`}
    >
      <ServerDownPopup isVisible={isServerDown} onRetry={handleRetry} />
      <BrowserRouter>
        <ClearProjectNameOnNavigate />
        <div className="flex w-full min-h-screen overflow-x-hidden">
          {isLoggedIn && token && !isVirtualAgentPath && (
            <div
              className={`fixed md:static top-0 left-0 h-full z-50 shrink-0 transform transition-transform duration-300 ease-in-out ${
                activeMenu
                  ? "translate-x-0"
                  : "-translate-x-full hidden md:block md:-translate-x-full"
              }`}
            >
              <Sidebar onLogout={handleLogout} />
            </div>
          )}

          <Routes>
            {isLoggedIn && token && (
              <Route path="/subsidebar/:sidebar" element={<Submenu />} />
            )}
          </Routes>

          {/* FIXED: Replaced 'w-screen' with 'flex-1 min-w-0 w-full' */}
          <div
            className={`dark:bg-main-dark-bg bg-main-bg h-screen md:ml-2 flex-1 min-w-0 w-full flex flex-col`}
          >
            {isLoggedIn && token && (
              <div className="fixed top-0 left-0 z-40 w-full md:static bg-main-bg dark:bg-main-dark-bg shadow-sm shrink-0">
                <Navbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
              </div>
            )}
            <div className="overflow-y-auto overflow-x-hidden h-full flex-1 min-w-0">
              <Routes>
                {/* ... (Your existing routes stay perfectly the same here) ... */}
                <Route
                  path="/"
                  element={
                    isLoggedIn && token ? (
                      hasActiveProjects ? (
                        <Navigate to="/ads-project-performance" />
                      ) : (
                        <Navigate to="/projects" />
                      )
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />
                <Route
                  path="/request-access"
                  element={
                    hasActiveProjects ? (
                      <Navigate to="/projects" />
                    ) : (
                      <RequestAccess />
                    )
                  }
                />
                {!isLoggedIn || !token ? (
                  <>
                    <Route
                      path="/login"
                      element={<Login onLogin={handleLogin} />}
                    />

                    <Route
                      path="/signup"
                      element={<Signup onSignup={handleLogin} />}
                    />
                    <Route
                      path="/signup-steps"
                      element={<SignupSteps onSignup={handleLogin} />}
                    />
                    <Route
                      path="/ForgotPassword"
                      element={<ForgotPassword />}
                    />
                    <Route path="/ResetPassword" element={<ResetPassword />} />
                    <Route path="/get-started" element={<GetStarted />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  </>
                ) : (
                  <>
                    <Route path="/projects" element={<Projects />} />
                    <Route
                      path="/CustomDateRangePicker"
                      element={<CustomDateRangePicker />}
                    />
                    <Route path="/strategy-ideas" element={<StrategyIdeas />} />
                    <Route path="/forecasting" element={<ForecastingTool />} />
                    <Route path="/billing-support" element={<Billing />} />
                    <Route
                      path="/keyword-analysis"
                      element={<KeywordAnalysis />}
                    />
                    <Route
                      path="/create-project"
                      element={<CreateProject step={1} />}
                    />
                    <Route
                      path="/connect-with-Googleads"
                      element={<CreateProject step={2} />}
                    />
                    <Route
                      path="/keyword-analysis-brand-specific"
                      element={<BrandSpecificKeyword />}
                    />
                    <Route
                      path="/keyword-analysis-non-brand-specific"
                      element={<NonBrandSpecificKeyword />}
                    />
                    <Route
                      path="/keyword-analysis-category-specific"
                      element={<CategorySpecific />}
                    />
                    <Route
                      path="/google-ads/setting/:projectId"
                      element={<ProjectConfig />}
                    />
                    <Route
                      path="/keyword-analysis-subcategory-specific"
                      element={<SubcategorySpecific />}
                    />
                    <Route path="/yoy-analysis" element={<YoyAnalysis />} />
                    <Route
                      path="/platform-analysis"
                      element={<PlatformAnalysis />}
                    />
                    <Route
                      path="/ads-project-performance"
                      element={<PaidAdsPage />}
                    />
                    <Route
                      path="/google-ads/group"
                      element={<Campaignlevel />}
                    />
                    <Route
                      path="/google-ads/CreateGroup"
                      element={<CreateGroup />}
                    />
                    <Route path="/google-ads/AddNotes" element={<AddNotes />} />
                    <Route path="/google-ads/subgroup" element={<Subgroup />} />
                    <Route
                      path="/google-ads/editgroup"
                      element={<Editgroup />}
                    />
                    <Route
                      path="/google-ads/editsubgroup"
                      element={<Editsubgroup />}
                    />
                    <Route
                      path="/google-ads/editcategory"
                      element={<Editcategory />}
                    />
                    <Route path="/check-GA-tag" element={<GADetection />} />
                    <Route path="/device-level" element={<DeviceLevel />} />
                    <Route
                      path="/website-traffic-analysis"
                      element={<TrafficAnalytics />}
                    />
                    <Route
                      path="/demographics-audience"
                      element={<Audience />}
                    />
                    <Route
                      path="/account-subscription"
                      element={<SubscriptionStatus />}
                    />
                    <Route
                      path="/tools/forecasting"
                      element={<ForecastingTool />}
                    />
                    <Route
                      path="/tools/seed-keyword-analysis"
                      element={<AdsPositionTool />}
                    />
                    <Route path="/tools/ad-crafting" element={<AdCrafting />} />
                    <Route
                      path="/media-planning-overview"
                      element={<CampaignPlanning />}
                    />
                    <Route
                      path="/media-planning/forecasting"
                      element={<ForecastingTool />}
                    />
                    <Route
                      path="/seed-keyword-analysis"
                      element={<AdsPositionTool />}
                    />
                    <Route
                      path="/media-planning/age"
                      element={<GADetectionTool />}
                    />
                    <Route
                      path="/media-planning/location"
                      element={<AdCrafting />}
                    />
                    <Route
                      path="/myspace/seed-keyword-analysis"
                      element={<AdsPositionTool />}
                    />
                    <Route
                      path="/myspace/check-GA-tag"
                      element={<GADetectionTool />}
                    />
                    <Route
                      path="/myspace/ad-crafting"
                      element={<AdCrafting />}
                    />
                    <Route
                      path="/profile"
                      element={<EditProfile handleLogout={handleLogout} />}
                    />
                    <Route path="/project-list" element={<ProjectList />} />
                    <Route
                      path="/edit-project/:projectId"
                      element={<EditProject />}
                    />
                    <Route
                      path="/google-ads/monthy-budget"
                      element={<Settings />}
                    />
                    <Route
                      path="/google-ads/setting/:projectId"
                      element={<Settings />}
                    />
                    <Route
                      path="/tools/change-log/:projectId"
                      element={<ChangeLog />}
                    />
                    <Route path="/ads-overview" element={<PaidAdsPage />} />
                    <Route
                      path="/google-ads-overview"
                      element={<GoogleAdsOverview />}
                    />
                    <Route
                      path="/google-ads/overview"
                      element={<GoogleAdsOverview />}
                    />
                    <Route
                      path="/google-ads/overview-reporting"
                      element={<GoogleAdsOverview />}
                    />
                    <Route
                      path="/google-ads/yesterday-reporting"
                      element={<GoogleAdsDailyReporting />}
                    />
                    <Route
                      path="/google-ads/reporting/daily-reporting"
                      element={<GoogleAdsDailyReporting />}
                    />
                    <Route
                      path="/google-ads/reporting/weekly-reporting"
                      element={<GoogleAdsWeeklyReporting />}
                    />
                    <Route
                      path="/google-ads/reporting/monthly-reporting"
                      element={<GoogleAdsMonthlyReporting />}
                    />
                    <Route
                      path="/google-ads/custom-reporting"
                      element={<CustomReporting />}
                    />
                    <Route path="/confi-ai" element={<PromptPage />} />
                    <Route path="/bid-strategies" element={<BidStrategies />} />
                    <Route
                      path="/google-ads/campaigns"
                      element={<CampaignsTable />}
                    />
                    <Route
                      path="/google-ads/channel"
                      element={<ChannelPage />}
                    />
                    <Route
                      path="/google-ads/campaign-groups"
                      element={<CampaignsGroupBy />}
                    />
                    <Route
                      path="/custom-column"
                      element={<CreateCustomColumn />}
                    />
                    <Route
                      path="/performance-custom-column"
                      element={<CustomColumnPerformance />}
                    />
                    <Route
                      path="/tools/ads-PromoRecap"
                      element={<PromoRecap />}
                    />
                    <Route path="/google-ads/ad-groups" element={<Adgroup />} />
                    <Route path="/google-ads/ads" element={<Ads />} />
                    <Route
                      path="/google-ads/change-history"
                      element={<Changehistory />}
                    />
                    <Route
                      path="/google-ads/search-keywords"
                      element={<Searchkeywords />}
                    />
                    <Route
                      path="/google-ads/search-terms"
                      element={<SearchTerms />}
                    />
                    <Route
                      path="/google-ads/locations"
                      element={<Location3 />}
                    />
                    <Route path="/virtual-Agent" element={<VirtualAgent />} />
                    <Route
                      path="/google-ads-alerts"
                      element={<GoogleAdsAlerts />}
                    />
                    <Route
                      path="/bing-ads-alerts"
                      element={<BingAdsAlerts />}
                    />
                    <Route
                      path="/create-task/:projectId"
                      element={<CreateTask />}
                    />
                    <Route
                      path="/project-details/:projectId"
                      element={
                        <ErrorBoundary>
                          <ProjectDetails />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/Bingdetails/:projectId"
                      element={<CreateDetails step={2} />}
                    />
                    <Route
                      path="/Googledetails/:projectId"
                      element={<CreateDetails step={1} />}
                    />
                    <Route path="/customer-support" element={<SupportPage />} />
                    <Route path="/videocall" element={<VideoCallPage />} />
                    <Route
                      path="/onboarding-audit"
                      element={<OnboardingAudit />}
                    />
                  </>
                )}
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
